import { AUTH_STATUS } from '@hems/util/src/constant/auth';
import { isExpired, parseJwt, removeAuthToken, saveAuthToken } from '@hems/util/src/helper/authHelper';
export const initState = {
    accessToken: null,
    idToken: null,
    userId: null,
    userName: null,
    roleCd: null,
    roleNm: null,
    fleetRole: null,
};
const prefix = 'user';
export const USER_ACTION = {
    SET_AUTH_TOKEN: `${prefix}/setAuthToken`,
    ACQUIRE_TOKEN: `${prefix}/acquireToken`,
    CLEAR: `${prefix}/clear`,
};
export const USER_MUTATION = {
    SET_FLEET_ROLE: `${prefix}/setFleetRole`,
};
const userModule = {
    namespaced: true,
    state: initState,
    getters: {
        isAuthenticated: (state) => !!state.accessToken,
        isTokenExpired: (state) => {
            const jwtObject = parseJwt(state.accessToken ?? '');
            return jwtObject ? isExpired(jwtObject) : false;
        },
    },
    mutations: {
        clear(state) {
            state.accessToken = null;
            state.idToken = null;
            state.userId = null;
            state.userName = null;
            state.roleCd = null;
            state.roleNm = null;
        },
        setRole(state, payload) {
            state.roleCd = payload.roleCd;
            state.roleNm = payload.roleNm;
        },
        setUserId(state, payload) {
            state.userId = payload;
        },
        setUserName(state, payload) {
            state.userName = payload;
        },
        setAccessToken(state, payload) {
            state.accessToken = payload;
        },
        setIdToken(state, payload) {
            state.idToken = payload;
        },
        removeToken(state) {
            state.accessToken = null;
            state.idToken = null;
        },
        setFleetRole(state, payload) {
            state.fleetRole = payload;
        },
    },
    actions: {
        setRole({ commit }, payload) {
            commit('setRole', payload);
        },
        setUserId({ commit }, payload) {
            commit('setUserId', payload);
        },
        setUserName({ commit }, payload) {
            commit('setUserName', payload);
        },
        acquireToken: ({ commit }, { accessToken, idToken }) => {
            if (!accessToken || !idToken) {
                return Promise.resolve(AUTH_STATUS.INVALID_ACCESS_TOKEN);
            }
            commit('setAccessToken', accessToken);
            commit('setIdToken', idToken);
            saveAuthToken({ accessToken, idToken });
            window.axiosInstance.setAccessToken(accessToken);
            return Promise.resolve(AUTH_STATUS.SUCCESS);
        },
        setAuthToken: async ({ commit }, authToken) => {
            if (!authToken.accessToken) {
                return AUTH_STATUS.INVALID_ACCESS_TOKEN;
            }
            const accessTokenJwtObject = parseJwt(authToken.accessToken);
            if (!accessTokenJwtObject) {
                return AUTH_STATUS.TOKEN_PARSING_ERROR;
            }
            const userId = accessTokenJwtObject.preferred_username;
            const userName = accessTokenJwtObject.name;
            commit('setUserId', userId);
            commit('setUserName', userName);
            commit('setAccessToken', authToken.accessToken);
            commit('setIdToken', authToken.idToken);
            window.axiosInstance.setAccessToken(authToken.accessToken);
            return AUTH_STATUS.SUCCESS;
        },
        clear({ commit }) {
            removeAuthToken();
            window.axiosInstance.clearAccessToken();
            commit('clear');
        },
    },
};
export default userModule;
